import { render } from "./CommentsComponentOld.vue?vue&type=template&id=553f0132&scoped=true"
import script from "./CommentsComponentOld.vue?vue&type=script&lang=js"
export * from "./CommentsComponentOld.vue?vue&type=script&lang=js"

import "./CommentsComponentOld.vue?vue&type=style&index=0&id=553f0132&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553f0132"]])

export default __exports__